export * from './bff-tags-list'

export const BASE_URL = 'BASE_BFF_URL'
